import React from 'react'
import styled from 'styled-components'
import { UserBookRecommendationResponse } from './UserBookRecommendationResponse'
import IndexContentContainer from '../../../index/IndexContentContainer'
import BooksitoutIcon from '../../../../config/BooksitoutIcon'
import BooksitoutImages from '../../../../images/BooksitoutImages'

interface Props {
	recommendation: UserBookRecommendationResponse
	colorType: 'card' | 'card-card'
	onLikeToggle: (id: number) => void
}

const UserBookRecommendationListRow: React.FC<Props> = ({ recommendation, colorType, onLikeToggle }) => {
	const { book, userNickname, reason, likeCount, isLiked } = recommendation

	return (
		<IndexContentContainer backgroundColorType={colorType} href={`/book/${book.isbn13}`} isNotHover={true}>
			<BookCover src={book.coverUrl || BooksitoutImages.Placeholder.bookCover} alt={book.title} />

			<ContentContainer>
				<BookTitle>{book.title}</BookTitle>
				<BookAuthor className="text-secondary">{book.authors}</BookAuthor>

				{reason && <Reason>"{reason}" — {userNickname}</Reason>}
				{!reason && <Reason className="text-secondary">— {userNickname}</Reason>}

				<LikeContainer
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
						onLikeToggle(recommendation.id)
					}}
				>
					<BooksitoutIcon.like color={isLiked ? '#66BB6B' : 'gray'} size={14} />
					<LikeCount $isLiked={isLiked}>{likeCount}</LikeCount>
				</LikeContainer>
			</ContentContainer>
		</IndexContentContainer>
	)
}

const BookCover = styled.img`
	width: 50px;
	height: 72px;
	object-fit: cover;
	border-radius: 4px;
	flex-shrink: 0;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-width: 0;
`

const BookTitle = styled.h5`
	font-size: 1.1rem;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

const BookAuthor = styled.p`
	font-size: 0.85rem;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

const Reason = styled.p`
	font-size: 0.85rem;
	margin: 5px 0 0 0;
	color: var(--sub-text-color);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

const LikeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	margin-top: 4px;
	cursor: pointer;
	align-self: flex-end;
`

const LikeCount = styled.span<{ $isLiked: boolean }>`
	font-size: 0.8rem;
	color: ${(props) => (props.$isLiked ? '#66BB6B' : 'gray')};
`

export default UserBookRecommendationListRow
